import React, { Component } from 'react';
import { submit, isSubmitting } from 'redux-form';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import 'react-table/react-table.css';

import SurveyTable from './components/SurveysTable';
import SurveyResultsAndDetails from './components/SurveyResultsAndDetails';
import SurveyMobile from './components/SurveysMobile';
import AddSurveyForm from './components/AddSurveyForm';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import * as SurveyActions from 'actions/landlordPropertiesActions';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import FlatButton from '@material-ui/core/Button';

import { getTranslatedString } from 'helpers/i18n';

export default withMobileDialog()(
  connect(
    store => ({
      properties: store.landlordProperties.properties,
      submitting: isSubmitting('create_survey_form')(store),
      surveys: store.landlordProperties.surveys,
      surveyQuestions: store.landlordProperties.surveyQuestions,
      surveyResults: store.landlordProperties.surveyResults,
    }),
    { ...SurveyActions, submit }
  )(
    class LandlordSurveys extends Component {
      state = {
        surveyIsOpen: false,
        showConfirmation: false,
        confirmDialogOpen: false,
        publishSurveyOnly: false,
        confirmDialogStopOpen: false,
        confirmDialogDeleteOpen: false,
        formData: null,
      };
      UNSAFE_componentWillMount = () => {
        this.props.getProperties({ for_multiselect: true });
        this.props.getSurveys();
      };

      endSurvey = () => {
        this.props
          .createOrUpdateSurvey(
            {
              status: 'ended',
            },
            this.state.surveyDetails.id
          )
          .then(() => {
            this.props.getSurveys();
            this.setState({
              confirmDialogStopOpen: false,
              surveyIsOpen: false,
              surveyId: null,
            });
          });
      };

      confirmDeleteSurvey = () => {
        this.props.deleteSurvey(this.state.surveyId).then(() => {
          this.props.getSurveys();
          this.setState({
            confirmDialogDeleteOpen: false,
            surveyIsOpen: false,
            surveyId: null,
          });
        });
      };

      deleteSurvey = surveyId => {
        this.setState({
          confirmDialogDeleteOpen: !this.state.confirmDialogDeleteOpen,
          surveyId,
        });
      };

      toggleSurveyDialog = () => {
        this.setState({
          surveyIsOpen: !this.state.surveyIsOpen,
          publishSurvey: null,
          surveyDetails: null,
        });
      };

      toggleConfirmDialog = (open = true) => {
        if (!open) {
          this.setState({
            publishSurvey: false,
          });
        }
        this.setState({
          confirmDialogOpen: open,
        });
      };

      toggleConfirmStopDialog = (open = true) => {
        this.setState({
          confirmDialogStopOpen: open,
        });
      };

      toggleConfirmDeleteDialog = (open = true) => {
        this.setState({
          confirmDialogDeleteOpen: open,
        });
      };

      toggleSurveyDetailsDialog = surveyDetails => {
        this.props.getSurveyQuestions(surveyDetails.id).then(() => {
          surveyDetails['survey_questions'] = this.props.surveyQuestions;

          this.setState({
            surveyIsOpen: !this.state.surveyIsOpen,
            surveyDetails: surveyDetails,
          });
        });
      };

      toggleSurveyResultsDialog = surveyDetails => {
        this.props.getSurveyResults(surveyDetails.id).then(() => {
          surveyDetails['survey_questions'] = this.props.surveyQuestions;

          this.setState({
            surveyIsOpen: !this.state.surveyIsOpen,
            surveyDetails: surveyDetails,
          });
        });
      };

      updateExpirationDate = formData => {
        const surveyId = this.state.surveyDetails ? this.state.surveyDetails.id : '';
        this.props.createOrUpdateSurvey(formData, surveyId).then(() => {
          this.toggleSurveyDialog();
          this.props.getSurveys();
        });
      };

      handlePublish = () => {
        this.setState(
          {
            publishSurvey: true,
          },
          () => this.props.submit('create_survey_form')
        );
      };

      handleSave = () => {
        this.setState(
          {
            publishSurvey: false,
          },
          () => this.props.submit('create_survey_form')
        );
      };

      handleSubmit = formData => {
        this.setState({ formData }, () => {
          if (this.state.publishSurvey) {
            this.toggleConfirmDialog();
          } else {
            this.postForm();
          }
        });
      };

      postForm = () => {
        const surveyId = this.state.surveyDetails ? this.state.surveyDetails.id : '';
        this.props
          .createOrUpdateSurvey(this.state.formData, surveyId, this.state.publishSurvey)
          .then(() => {
            this.toggleConfirmDialog(false);
            this.toggleSurveyDialog();
            this.props.getSurveys();
          });
      };

      render() {
        const { fullScreen } = this.props;

        return (
          <div className="body" role="main">
            <div className="centers">
              <Dialog
                disableBackdropClick
                fullScreen={fullScreen}
                open={this.state.surveyIsOpen}
                onClose={this.toggleSurveyDialog}
                aria-labelledby="add-new-survey"
                classes={{
                  paper: 'form-dialog',
                }}
              >
                <DialogTitle id="add-new-survey">
                  <h3 style={{ textAlign: 'center', margin: 0 }}>
                    {this.state.surveyDetails
                      ? getTranslatedString('landlordPortal.surveys.surveyDetails')
                      : getTranslatedString('landlordPortal.surveys.createSurvey')}
                  </h3>
                </DialogTitle>
                <DialogContent>
                  {(!this.state.surveyDetails || this.state.surveyDetails.status === 'editing') && (
                    <AddSurveyForm
                      initialValues={this.state.surveyDetails || { properties: [] }}
                      properties={this.props.properties}
                      onSubmit={this.handleSubmit}
                    />
                  )}
                  {this.state.surveyDetails &&
                    this.state.surveyDetails.status !== 'editing' && (
                      <SurveyResultsAndDetails
                        surveyDetails={this.state.surveyDetails}
                        initialValues={{
                          expiration_date: this.state.surveyDetails.expiration_date,
                        }}
                        surveyResults={this.props.surveyResults}
                        onSubmit={this.updateExpirationDate}
                      />
                    )}
                </DialogContent>
                <DialogActions style={{ display: 'block' }}>
                  <FlatButton
                    onClick={this.toggleSurveyDialog}
                    id="close-button"
                    style={{ color: AccentColor() }}
                  >
                    {getTranslatedString('landlordPortal.surveys.close')}
                  </FlatButton>
                  {this.state.surveyDetails &&
                    this.state.surveyDetails.published && (
                      <FlatButton
                        variant="raised"
                        onClick={() => this.toggleConfirmStopDialog('stop')}
                        disabled={this.props.submitting}
                        id="submit-button"
                        style={{
                          color: 'white',
                          backgroundColor: this.props.submitting
                            ? colors.LIGHT_GRAY
                            : AccentColor(),
                        }}
                      >
                        {getTranslatedString('landlordPortal.surveys.endSurvey')}
                      </FlatButton>
                    )}
                  {(!this.state.surveyDetails || this.state.surveyDetails.status === 'editing') && (
                    <span>
                      <FlatButton
                        variant="raised"
                        onClick={this.handlePublish}
                        disabled={this.props.submitting}
                        id="submit-button"
                        style={{
                          color: 'white',
                          backgroundColor: this.props.submitting
                            ? colors.LIGHT_GRAY
                            : AccentColor(),
                        }}
                      >
                        {getTranslatedString('landlordPortal.surveys.publish')}
                      </FlatButton>
                      <FlatButton
                        onClick={this.handleSave}
                        disabled={this.props.submitting}
                        id="submit-button"
                        style={{
                          color: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
                        }}
                      >
                        {getTranslatedString('landlordPortal.surveys.save')}
                      </FlatButton>
                    </span>
                  )}
                </DialogActions>
              </Dialog>

              <MediaQuery query="(min-device-width: 650px)">
                <SurveyTable
                  optionsDropdown={this.state.surveyIsOpen || this.state.surveyId}
                  toggleSurveyDetailsDialog={this.toggleSurveyDetailsDialog}
                  toggleSurveyResultsDialog={this.toggleSurveyResultsDialog}
                  toggleSurveyDialog={this.toggleSurveyDialog}
                  deleteSurvey={this.deleteSurvey}
                  surveys={this.props.surveys}
                />
              </MediaQuery>

              <MediaQuery query="(max-device-width: 650px)">
                <SurveyMobile
                  optionsDropdown={this.state.surveyIsOpen || this.state.surveyId}
                  toggleSurveyDetailsDialog={this.toggleSurveyDetailsDialog}
                  toggleSurveyResultsDialog={this.toggleSurveyResultsDialog}
                  toggleSurveyDialog={this.toggleSurveyDialog}
                  deleteSurvey={this.deleteSurvey}
                  surveys={this.props.surveys}
                />
              </MediaQuery>
            </div>
            <ConfirmationDialog
              showDialog={this.state.confirmDialogOpen}
              hideDialog={() => this.toggleConfirmDialog(false)}
              userConfirmVerbiage={getTranslatedString('landlordPortal.surveys.publish')}
              dialogTitle={getTranslatedString('landlordPortal.surveys.publishSurvey')}
              dialogBodyVerbiage={getTranslatedString('landlordPortal.surveys.confirmPublish')}
              userConfirmAction={this.postForm}
            />
            <ConfirmationDialog
              showDialog={this.state.confirmDialogStopOpen}
              hideDialog={() => this.toggleConfirmStopDialog(false)}
              userConfirmVerbiage={getTranslatedString('landlordPortal.surveys.end')}
              dialogTitle={getTranslatedString('landlordPortal.surveys.endSurvey')}
              dialogBodyVerbiage={getTranslatedString('landlordPortal.surveys.confirmEndSurvey')}
              userConfirmAction={this.endSurvey}
            />
            <ConfirmationDialog
              showDialog={this.state.confirmDialogDeleteOpen}
              hideDialog={() => this.toggleConfirmDeleteDialog(false)}
              userConfirmVerbiage={getTranslatedString('landlordPortal.surveys.delete')}
              dialogTitle={getTranslatedString('landlordPortal.surveys.deleteSurvey')}
              dialogBodyVerbiage={getTranslatedString('landlordPortal.surveys.confirmDeleteSurvey')}
              userConfirmAction={this.confirmDeleteSurvey}
            />
          </div>
        );
      }
    }
  )
);
